import React from 'react';

const NotFound = () => {
    return <h1 className='text-gunmetal fs-40 mt-50px text-center maxis-bold'>404 Not Found</h1>;
};

export default NotFound;
